import { render } from "./ForgetPassword.vue?vue&type=template&id=02dca5c2&scoped=true&ts=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts"

import "./ForgetPassword.vue?vue&type=style&index=0&id=02dca5c2&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02dca5c2"]])

export default __exports__